import React, { useCallback, useEffect, useState, useRef, useContext } from 'react';
import type { FC } from 'react';
import HeaderUpload, { UploadResult } from 'src/components/HeadUploadMobile';
import { useRouter } from 'next/router';
import * as AccountServer from 'src/model/host-account';
import { AppContext } from '@utils/browser/app-context';
import IndustrySelect from './IndustrySelect';
import DefaultAvatar from '@assets/imgs/default-avatar.svg';
// eslint-disable-next-line import/no-webpack-loader-syntax
import BgField from './BgField';
import beaconReport from '@utils/beacon';
import { HostDetailData } from 'src/model/host-account';
import DrawerField from './DrawerField';
import TagInput from './TagInput';
import TextInput from './TextInput';
import { Form, Button, useClassNames, Input, message, Checkbox } from '@tencent/tea-component';
import { Icon, Bubble } from '@tencent/met-ui';
import MobileForm from '@tencent/tpm-meeting-active/lib/MobileForm';
import '@tencent/tpm-meeting-active/lib/MobileForm/style';
import MobileFooterPanel from '@tencent/tpm-meeting-active/lib/MobileFooterPanel';
import Layout from '@tencent/tpm-meeting-active/lib/Layout';
import '@tencent/tpm-meeting-active/lib/MobileFooterPanel/style';
// import '@tencent/tpm-meeting-active/pages/MobileEditInfoPage/style/index.scss';
import useProtocol from '../hooks/useProtocol';
import classNames from 'classnames';
import style from './index.module.scss';
import useReport from '../hooks/useReport';
import { getRemoteStatus } from '@model/show-activity-room';
import { encryptUrl } from '@utils/log-util';

const Mobile: FC<{ isEdit?: boolean; userInfo: { avatarUrl: string; hostName: string } }> = ({
  isEdit,
  userInfo,
}) => {
  const [avatar, setAvatar] = useState<string>(DefaultAvatar);
  /* eslint-disable-next-line @typescript-eslint/naming-convention */
  const { Body, Content } = Layout;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { Margin } = useClassNames();
  const avatarUploadResult = useRef<UploadResult>({ url: '', cosId: '' });
  const hostId = useRef<number | string>();
  const [loading, setLoading] = useState(false);
  const route = useRouter();
  const { opt } = route.query;
  const oldDetail = useRef<HostDetailData>();
  const { updateAppCtxHostDetail, hostDetail } = useContext(AppContext);
  const { isAgree, changeAgree, protocolList } = useProtocol();
  const { exposureReport, modifyReport, nameReport, industryReport, creatReport } = useReport();
  const [formData, setFromData] = useState<{
    industry: Array<{ value: string; label: string }>;
    name: string;
    tag?: Array<string>;
    desc?: string;
    bg_mobile_url?: string;
  }>({
    name: '',
    industry: [],
    tag: [],
    desc: '',
    bg_mobile_url: '',
  });
  useEffect(() => {
    if (isEdit) {
      setLoading(true);
      if (hostDetail.host_id) {
        setAvatar(hostDetail?.avatar_url || '');
        hostId.current = hostDetail.host_id;
        avatarUploadResult.current.url = hostDetail.avatar_url || '';
        oldDetail.current = hostDetail;
        setFromData({
          name: hostDetail?.host_name || '',
          industry: hostDetail?.industry_infos?.length
            ? hostDetail?.industry_infos?.map((industry) => ({
                label: industry.industry_name || '',
                value: industry.industry_code,
              }))
            : [],
          tag: hostDetail.label,
          desc: hostDetail.introduction || '',
          bg_mobile_url: hostDetail.bg_mobile_url,
        });
        setLoading(false);
      }
    }
  }, [hostDetail]);

  useEffect(() => {
    if (isEdit) {
      beaconReport('eventplace_hostview_personalinfo_null_null_null_explore');
    } else {
      beaconReport('eventplace_createhost_null_null_null_null_explore');
      exposureReport();
    }
  }, [isEdit, exposureReport]);

  useEffect(() => {
    if (userInfo?.avatarUrl) {
      setAvatar((cur) => {
        if (cur === DefaultAvatar) {
          return userInfo.avatarUrl;
        }
        return cur;
      });
    }
  }, [userInfo]);

  const submit = useCallback(() => {
    const { name: userName, industry, tag, desc } = formData;
    if (!userName?.trim()) {
      message.error({ content: '请填写主办方名称' });
      return;
    }
    if (!industry?.[0]?.value) {
      message.error({ content: '请选择主办方行业' });
      return;
    }
    if (!isEdit && !avatarUploadResult.current.cosId && !avatar) {
      message.error({ content: '请选择主办方头像' });
      return;
    }

    setLoading(true);
    let req: Promise<any>;
    if (isEdit) {
      req = AccountServer.updateHostDetail({
        host_id: hostId.current!,
        host_name: userName,
        avatar_cos_key: avatarUploadResult.current.cosId,
        industry_codes: industry?.map((item) => item.value) || [],
        label: tag || [],
        introduction: desc || '',
      }).then(() => {
        const reportData = {
          // 上报日志需要脱敏
          // hostid: hostId.current,
          industry: industry?.[0]?.label,
          // hostname: userName,
          // hostlabel: tag,
          avatarchange: avatarUploadResult.current.cosId ? 1 : 0,
          infochange: desc === oldDetail.current?.introduction ? 0 : 1,
          pcbanner: 0,
          mobilebanner: 0,
        };
        beaconReport('eventplace_hostview_personalinfo_save_null_null_click', reportData);
        window.nextAegis?.infoAll(`updateDetail: ${JSON.stringify(reportData)}`);
      });
    } else {
      req = AccountServer.createAccount({
        host_name: userName,
        avatar_url: avatarUploadResult.current.url || avatar,
        avatar_cos_key: avatarUploadResult.current.cosId,
        industry_code: industry?.[0]?.value,
      }).then((res) => {
        // 创建埋点
        beaconReport('eventplace_createhost_null_success_null_null_click', {
          industry: industry?.[0]?.label,
          hostname: userName,
        });
        getRemoteStatus();
        hostId.current = res;
        creatReport(userName, industry?.[0]?.label);
        window.nextAegis?.infoAll(
          `createPersonal: ${JSON.stringify({ industry: industry?.[0]?.label })}`,
        );
      });
    }
    req
      .then(() => {
        updateAppCtxHostDetail(hostId.current);
        message.success({ content: `${isEdit ? '更新' : '创建'}成功` });
        let path = '/home';
        if (hostId.current) path += `?host_id=${hostId.current}`;
        route.replace(path);
      })
      .catch((e) => {
        const err = typeof e === 'string' ? e : JSON.stringify(e);
        message.error({ content: `${err ? err : `${isEdit ? '更新' : '创建'}失败,请稍后重试`}` });
        window.nextAegis?.error(`PersonalUpdate: ${isEdit} ${err}`);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [formData, avatar, creatReport]);

  const onAvatarUploaded = useCallback((data: UploadResult) => {
    avatarUploadResult.current = data;
    setAvatar(data.url);
    window.nextAegis?.infoAll(`AvatarUploaded: ${encryptUrl(data.url)}`);
    if (isEdit) {
      beaconReport('eventplace_hostview_personalinfo_image_null_null_click');
    } else {
      beaconReport('eventplace_createhost_null_image_null_null_click');
    }
  }, []);

  const openPage = () => {
    beaconReport('eventplace_createhost_null_example_null_null_click');
    if (typeof wemeet === 'undefined') {
      route.push('/sample/index.html');
    } else {
      wemeet.ui.openNewPage({
        params: {
          url: `${window.location.origin}${process.env.basePath}/sample/index.html`,
        },
      });
    }
  };
  const handleNameClick = useCallback(() => {
    if (!isEdit) {
      nameReport();
    }
  }, [isEdit, nameReport]);

  const handleUploadClick = useCallback(() => {
    if (!isEdit) {
      modifyReport();
    }
  }, [isEdit, modifyReport]);

  const handleIndustryClick = useCallback(() => {
    if (!isEdit) {
      industryReport();
    }
  }, [isEdit, industryReport]);

  return (
    <div className={classNames(style['pg-mobile-info-box'], 'pg-mobile-info')}>
      <Layout full responsive>
        <Body>
          <Content>
            <div className="info-con">
              <div className={style['info-bg']}>
                {!isEdit && (
                  <div className={style['version-tip']}>
                    {/* eslint-disable-next-line @typescript-eslint/no-require-imports */}
                    <img src={require('src/assets/imgs/tips.svg')} className={style.tipsIcon} />
                    <p>更新客户端到3.8及以上版本体验活动空间功能</p>
                  </div>
                )}
              </div>
              <div className={style['upload-avatar']}>
                <HeaderUpload
                  onUploadClick={handleUploadClick}
                  defaultUrl={avatar}
                  onUploadComplete={onAvatarUploaded}
                  txt={isEdit ? '更新头像' : '上传头像'}
                />
              </div>
              <MobileForm className={style['bottom-line']}>
                <Form.Item required label="主办方名称" className="none-arrow label-name">
                  <Input
                    maxLength={30}
                    onClick={handleNameClick}
                    placeholder="请输入"
                    value={formData.name}
                    onChange={(value) => {
                      setFromData({ ...formData, name: value });
                    }}
                  />
                </Form.Item>
                <IndustrySelect
                  onClick={handleIndustryClick}
                  name="industry"
                  isEdit={isEdit}
                  label={
                    <span className={style.industryLabel}>
                      <span className={style.labelName}>行业</span>
                      {!isEdit && (
                        <Bubble
                          className={style.industryBubble}
                          trigger="click"
                          content="行业一旦选定无法修改，创建的活动类型与行业一致，请谨慎选择"
                          arrowPointAtCenter
                          placement="top-start"
                        >
                          <Icon
                            type="info"
                            onClick={(e) => {
                              e?.preventDefault();
                              e?.stopPropagation();
                            }}
                          />
                        </Bubble>
                      )}
                    </span>
                  }
                  selectVal={formData.industry}
                  onChange={(item: any) => {
                    setFromData({ ...formData, industry: item });
                  }}
                />
                {isEdit
                  ? [
                      <DrawerField
                        name="tag"
                        label="标签"
                        key="tags"
                        value={formData.tag}
                        defalutVisible={opt === 'tag'}
                        onChange={(item: any) => {
                          setFromData({ ...formData, tag: item });
                        }}
                      >
                        <TagInput />
                      </DrawerField>,
                      <DrawerField
                        name="desc"
                        label="主办方介绍"
                        key="desc"
                        layout="vertical"
                        className={style['mt-8']}
                        value={formData.desc}
                        onChange={(item: any) => {
                          console.log(item);
                          setFromData({ ...formData, desc: item });
                        }}
                      >
                        <TextInput maxLength={1000} className="text-input" />
                      </DrawerField>,
                    ]
                  : null}
              </MobileForm>
            </div>
            {isEdit && (
              <div className={Margin.Top['2n']}>
                <MobileForm>
                  <BgField
                    name="bg_mobile_url"
                    className="form-img__label"
                    label="背景图"
                    key="bg"
                    value={formData.bg_mobile_url}
                  />
                </MobileForm>
              </div>
            )}
          </Content>
          {!isEdit && (
            <div className={style['protocol-box']}>
              <Checkbox value={isAgree} onChange={changeAgree}>
                我已阅读并遵守
                <span>
                  {protocolList.map((protocolItem, index) => {
                    const { name, url } = protocolItem;
                    return (
                      <>
                        <a href={url} target="_blank" rel="noreferrer">
                          《{name}》
                        </a>
                        {index !== protocolList.length - 1 && '和'}
                      </>
                    );
                  })}
                </span>
              </Checkbox>
            </div>
          )}
          <MobileFooterPanel responsive={true} className={style['info-btn-box']}>
            {!isEdit && (
              <Button type="weak" className={style['info-btn']} onClick={openPage}>
                查看示例
              </Button>
            )}
            <Button
              className={
                !isEdit
                  ? classNames(style['info-btn'])
                  : classNames('size-l size-full-width has-maxwidth')
              }
              type="primary"
              onClick={submit}
              disabled={
                loading ||
                (!isEdit && !(isAgree && formData?.industry?.[0]?.value && formData?.name?.trim()))
              }
            >
              {isEdit ? '提交' : '创建'}
            </Button>
          </MobileFooterPanel>
        </Body>
      </Layout>
    </div>
  );
};

export default Mobile;
